<script>
  import { mqttDevices, mqttSchedules } from "../../../service/mqtt";

  $: deviceList = Object.values($mqttDevices);
  $: totalDevices = deviceList.length;
  $: onlineDevices = deviceList.filter((d) => d.online === "true").length;
  $: onlineRate =
    totalDevices > 0 ? Math.round((onlineDevices / totalDevices) * 100) : 0;

  $: poweredOn = deviceList.filter((d) => d.power === "ON").length;
  $: poweredOff = deviceList.filter((d) => d.power === "OFF").length;

  $: totalSchedules = $mqttSchedules.length;
  $: enabledSchedules = $mqttSchedules.filter((s) => s.enabled).length;
</script>

<div class="row mb-2">
  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 mb-2">
    <div class="card h-100">
      <div
        class="card-body text-center d-flex flex-column justify-content-center"
      >
        <h5 class="card-title mb-0">Total Devices</h5>
        <h2 class="text-primary mt-2 mb-0">{totalDevices}</h2>
      </div>
    </div>
  </div>

  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 mb-2">
    <div class="card h-100">
      <div
        class="card-body text-center d-flex flex-column justify-content-center"
      >
        <h5 class="card-title mb-0">Online Rate</h5>
        <h2 class="text-success mt-2 mb-0">{onlineRate}%</h2>
        <small class="text-muted">{onlineDevices} / {totalDevices}</small>
      </div>
    </div>
  </div>

  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 mb-2">
    <div class="card h-100">
      <div
        class="card-body text-center d-flex flex-column justify-content-center"
      >
        <h5 class="card-title mb-0">Power State</h5>
        <div class="d-flex justify-content-center align-items-center mt-2">
          <span class="badge bg-warning me-2 p-2">ON: {poweredOn}</span>
          <span class="badge bg-secondary p-2">OFF: {poweredOff}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 mb-2">
    <div class="card h-100">
      <div
        class="card-body text-center d-flex flex-column justify-content-center"
      >
        <h5 class="card-title mb-0">Next Schedules</h5>
        <h2 class="text-info mt-2 mb-0">{totalSchedules}</h2>
        <small class="text-muted">Enabled: {enabledSchedules}</small>
      </div>
    </div>
  </div>
</div>
